module.exports = __webpack_public_path__ + "img/16.d8904879.svg";